import axios, { AxiosError } from 'axios'
import jwt_decode from 'jwt-decode'

import history from '../router/CustomHistory'
import { IRoleEnum } from '../types/router'
import { clearLocalStorage } from '../utils/auth'

import getAccessToken from './refreshToken'

export interface IJWT {
    exp: number
    fresh: boolean
    iat: number
    jti: string
    nbf: number
    subject: {
        _id: string
        role: IRoleEnum
    }
    type: string
}

const axiosAuth = axios.create({
    baseURL: process.env.BACKEND_URL,
    headers: { 'Content-Type': 'application/json' },
    withCredentials: true,
})

axiosAuth.interceptors.request.use(
    async (config) => {
        let accessToken = localStorage.getItem('accessToken')
        const refreshToken = localStorage.getItem('refreshToken')

        const todayDate = new Date().getTime()
        let isExpired = false

        if (accessToken) {
            const decodedAccessToken = jwt_decode(accessToken) as IJWT

            const tokenExp = decodedAccessToken.exp * 1000
            if (todayDate > tokenExp) {
                isExpired = true
            }
        }

        if (refreshToken && isExpired) {
            const decodedRefreshToken = jwt_decode(refreshToken) as IJWT
            const refreshTokenExp = decodedRefreshToken.exp * 1000
            if (todayDate > refreshTokenExp) {
                clearLocalStorage()

                history.replace('/login')
            }

            const response = await getAccessToken()
            accessToken = typeof response === 'string' ? response : ''
        }

        if (config?.headers && accessToken && refreshToken) {
            config.headers.Authorization = `Bearer ${accessToken}`
        }
        return config
    },
    (error) => {
        const { response } = error
        const shouldRedirect = response && [401, 403].includes(response.status)

        if (shouldRedirect) {
            history.replace('/login')
        }

        return Promise.reject(error)
    }
)

axiosAuth.interceptors.response.use(
    (response) => response,
    (error: AxiosError) => {
        return Promise.reject(error)
    }
)

export default axiosAuth
